<div class="lum-ui-copyable__content">
  <input
    class="lum-ui-copyable__input  lum-u-reset"
    readonly
    [value]="content || ''"
    (focus)="onContentFocus($event)"
  />
</div>
<mat-divider [vertical]="true" class="lum-ui-copyable__divider"></mat-divider>
<button
  class="lum-ui-copyable__button  linkish"
  title="Copy to Clipboard"
  [disabled]="!content"
  (click)="onCopy($event)"
>
  <icon name="clipboard-add"></icon>
</button>
